import styled from "styled-components";
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';

import StyledTheme from '../../context/styledTheme';

export const HorizontalMenuContainer = styled.div`
    display: flex;
    width: 100%;
`;

export const StyledBottomNavigation = styled(BottomNavigation)`
  && {
    width: 100%;
    text-align: center;
    background-color: ${({ theme }: StyledTheme) => theme.headerSurface};
    box-shadow: none;
  }
`;

export const StyledBottomNavigationAction = styled(BottomNavigationAction)`
  && {
    color: ${({ theme }: StyledTheme) => theme.text};
  }
  &&.Mui-selected {
    background-color: transparent;
    color: ${({ theme }: StyledTheme) => theme.text};
  }
`;
